var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPro({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 12,
    viewBox: "0 0 33 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame 177"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Original"
  }, /*#__PURE__*/React.createElement("path", {
    id: "P",
    d: "M1.5 12V7.5M1.5 7.5V1.5H4.59487C5.48521 1.5 6.32956 1.89547 6.89954 2.57945V2.57945C7.82665 3.69199 7.82665 5.30801 6.89954 6.42055V6.42055C6.32956 7.10453 5.48521 7.5 4.59487 7.5H1.5Z",
    stroke: "#5714CC",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "R",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5 0H11V1.5V7.5V12H14V9H15.5949C15.6049 9 15.6149 8.99997 15.6249 8.9999L17.5 12H20.5L18.1344 8.21499C18.4738 7.98301 18.7831 7.7033 19.0519 7.38083C20.4425 5.71202 20.4425 3.28798 19.0519 1.61917C18.1969 0.593203 16.9304 0 15.5949 0H12.5ZM15.5949 6H14V3H15.5949C16.04 3 16.4622 3.19773 16.7472 3.53972C17.2108 4.09599 17.2108 4.90401 16.7472 5.46028C16.4622 5.80227 16.04 6 15.5949 6Z",
    fill: "#5714CC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "O",
    d: "M23.5 5.5V6.5C23.5 8.70914 25.2909 10.5 27.5 10.5C29.7091 10.5 31.5 8.70914 31.5 6.5V5.5C31.5 3.29086 29.7091 1.5 27.5 1.5C25.2909 1.5 23.5 3.29086 23.5 5.5Z",
    stroke: "#5714CC",
    strokeWidth: 3
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPro);
export default __webpack_public_path__ + "static/media/pro.441b9011e2d5361c70ec1a346e32317e.svg";
export { ForwardRef as ReactComponent };